<script setup lang="ts">
import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: PlatformSaleItemEntity;
}

const { sale } = defineProps<Props>();

// COMPOSABLES
const { tt, formatUnits } = useTypedI18n();
const { isMonoAsset, isBundleMono } = useSaleType(() => sale.type);
const { formatFirstRegistration } = useAssetRegistration();

// DATA
const badgeUi = badgeResponsiveSizeUi('md', 'lg');

const showKeyAttributes = computed<boolean>(() => isMonoAsset.value || isBundleMono.value);
</script>

<template>
    <div class="flex flex-wrap gap-3">
        <SaleBadges :sale="sale" />

        <div v-if="showKeyAttributes" class="flex gap-3">
            <UBadge color="primary-dark" variant="solid" :ui="badgeUi" class="flex gap-x-2" icon="lucide:calendar">
                <span class="hidden md:inline"> {{ tt('asset.firstRegistration') }}: </span>
                {{ formatFirstRegistration(sale.mainAsset) }}
            </UBadge>

            <UBadge
                v-if="sale.mainAsset.km !== null"
                color="primary-dark"
                variant="solid"
                :ui="badgeUi"
                class="flex gap-x-2"
                icon="lucide:circle-gauge"
            >
                {{ formatUnits.km(sale.mainAsset.km) }}
            </UBadge>

            <UBadge v-if="sale.mainAsset.euroNorm" color="primary-dark" variant="solid" :ui="badgeUi" class="flex gap-x-2" icon="lucide:bus-front">
                {{ tt(`asset.euroNorm.${sale.mainAsset.euroNorm}`) }}
            </UBadge>
        </div>
    </div>
</template>
